import axios from "../../axios-config";

export const fetchMetaConnectionStatus = async () => {
    const res = await axios.get("/user/v1/meta-connection-status");
    return (
        res.data?.data ?? {
            connected: false,
            facebookUserId: "",
            tokenStatus: "missing",
            tokenExpiresAt: null,
            needsReconnect: false,
            code: null,
        }
    );
};
